module.exports = __webpack_public_path__ + "img/popup-bg.5b49aa2b.png";